import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "scenic-conatainer"
};
const _hoisted_2 = {
  class: "parkservice-content"
};
import { ref, reactive, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import ScenicContent from '@/components/sceniccontent/index.vue';
import ScenicList from '@/components/sceniclist/index.vue';
import Footer from '@/components/footer/index.vue';
import { menus, newsList } from '@/api';
import { nextTick } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const headerbg = require('@/assets/scebg22ec02b.png');
    const tabsWrapRef = ref(null);
    const scenicList = reactive([]);
    const serviceList = reactive([]);
    const defaultTab = ref(4);

    // PC端鼠标拖动实现
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let navContainer = null;
    const handleMouseDown = e => {
      if (e.button !== 0) return;
      if (!navContainer) {
        navContainer = tabsWrapRef.value?.querySelector('.van-tabs__nav');
      }
      if (!navContainer) return;
      isDragging = true;
      startX = e.pageX - navContainer.offsetLeft;
      scrollLeft = navContainer.scrollLeft;
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    };
    const handleMouseMove = e => {
      if (!isDragging || !navContainer) return;
      e.preventDefault();
      const x = e.pageX - navContainer.offsetLeft;
      const walk = (x - startX) * 1.5;
      navContainer.scrollLeft = scrollLeft - walk;
    };
    const handleMouseUp = () => {
      isDragging = false;
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
    onMounted(() => {
      if (tabsWrapRef.value) {
        tabsWrapRef.value.addEventListener('mousedown', handleMouseDown);
      }
      nextTick(() => {
        loadScenicData();
      }); // 等待 DOM 完全加载后再执行 loadScenicData 函数
    });
    const loadScenicData = async () => {
      try {
        const {
          data
        } = await menus({
          type: 3
        });
        // console.log('loadScenicData: ', data)
        serviceList.push(...data); // 将数据添加到 scenicList 中
        // 检查 params 参数中的 tabId
        if (route.params?.tabId) {
          console.log('route.params:', route.params);
          defaultTab.value = route.params.tabId;
        } else {
          defaultTab.value = data[0]?.id;
        }
      } catch (error) {
        console.log('loadScenicData error: ', error);
      }
    };
    onUnmounted(() => {
      if (tabsWrapRef.value) {
        tabsWrapRef.value.removeEventListener('mousedown', handleMouseDown);
      }
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    });
    const handleTabChange = item => {
      // console.log('handleTabChange: ', item)
      handleScenicList(item);
    };
    const handleScenicList = async tabItem => {
      try {
        scenicList.length = 0; // 清空 scenicList
        const {
          data: {
            list,
            count
          }
        } = await newsList({
          mid: tabItem?.id,
          page: 1,
          pageSize: 999
        });
        // console.log('handleScenicList: ', list)
        // 为每条数据添加 tabName 字段
        const dataWithTabName = list.map(item => ({
          ...item,
          tabName: tabItem?.name || ''
        }));
        scenicList.push(...dataWithTabName); // 将数据添加到 scenicList 中
      } catch (error) {
        console.log('handleScenicList error: ', error);
      }
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "news-header",
        style: _normalizeStyle({
          backgroundImage: `url(${_unref(headerbg)})`
        })
      }, [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "header-title-ch"
      }, "著名景点", -1), _createElementVNode("div", {
        class: "header-title"
      }, "ATTRACTIONS", -1)]))], 4), _createElementVNode("div", _hoisted_2, [_createVNode(ScenicContent, {
        "service-list": serviceList,
        onTabChange: handleTabChange,
        "default-tab": defaultTab.value,
        "show-content": !_ctx.$route.params.id
      }, null, 8, ["service-list", "default-tab", "show-content"]), _createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [_ctx.$route.params.id ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: 0
          })) : (_openBlock(), _createBlock(ScenicList, {
            key: 1,
            list: scenicList
          }, null, 8, ["list"]))]),
          _: 2
        }, 1024)]),
        _: 1
      })]), _createVNode(Footer)]);
    };
  }
};